<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputRegistrationId" });
import { InputText } from "../../../../inputs/index.js";
import { REGISTRATION_NUMBER } from "./config/registration-number.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
export let countryCode = "";
$: hint = REGISTRATION_NUMBER[countryCode] || "";
</script>

<InputText
    bind:value
    placeholder = 'resource.organization.properties.registration_id.placeholder'
    label = 'resource.organization.properties.registration_id.label'
    name = 'organization.registration_id'
    { hint }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>